module.exports = __webpack_public_path__ + "img/bj33.2e8aef48.png";